import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { OrganisationUser } from "../../types/types";

interface Props {
  target: OrganisationUser | null;
  pending: boolean;
  error: string | null;
  needsRefresh: boolean;
  refreshing: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onRefresh: () => void;
  onExited?: () => void;
}

const RemoveStaffAccessDialog: React.FC<Props> = ({
  target, pending, error, needsRefresh, refreshing, onClose, onConfirm, onRefresh, onExited,
}) => (
  <Dialog
    open={!!target}
    onClose={() => { if (!pending && !needsRefresh) onClose(); }}
    disableEscapeKeyDown={pending || needsRefresh}
    aria-labelledby="remove-staff-access-title"
    aria-describedby="remove-staff-access-description"
    TransitionProps={{ onExited }}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle id="remove-staff-access-title">Remove staff access?</DialogTitle>
    <DialogContent>
      <div className="mb-4 break-words">
        <p className="font-semibold">{target?.full_name}</p>
        <p>{target?.email}</p>
      </div>
      <p id="remove-staff-access-description">
        This will remove {target?.full_name}'s access to your school's Pedagogue account and free one licence. Their account and learning history will be retained.
      </p>
      <p className="mt-3">If you remove the wrong person, contact Pedagogue to restore their access.</p>
      {error && <p role="alert" className="mt-4 text-red-700">{error}</p>}
    </DialogContent>
    <DialogActions sx={{ p: 2, flexWrap: "wrap", gap: 1 }}>
      {needsRefresh ? (
        <button onClick={onRefresh} disabled={refreshing} className="rounded border border-gray-300 px-4 py-2 disabled:opacity-60">
          Refresh staff list
        </button>
      ) : (
        <>
          <button autoFocus onClick={onClose} disabled={pending} className="rounded border border-gray-300 px-4 py-2 disabled:opacity-60">Cancel</button>
          <button onClick={onConfirm} disabled={pending} aria-busy={pending} className="rounded bg-red-700 px-4 py-2 text-white disabled:opacity-60">
            {pending ? "Removing access…" : "Remove access"}
          </button>
        </>
      )}
    </DialogActions>
  </Dialog>
);

export default RemoveStaffAccessDialog;
